import { initSwiper } from '../components/swiper';
import initCartUpsellAtc from '../components/cart-upsell-atc';
import changeCart from './changeCart';
import { debounce } from 'throttle-debounce';
import { SETTINGS } from '../utils/constants';
import getLocalePrefix from './getLocalePrefix';

const renderMinicart = async () => {
  const minicartLineItemSelector = '[data-minicart-line-item]';

  const getMinicartData = async () => {
    const localePrefix = getLocalePrefix();
    const url = `${window.location.origin}${localePrefix}/cart?view=minicart`;
    try {
      const res = await fetch(url);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      return await res.text();
    } catch (e) {
      console.error('Failed to fetch minicart:', e);
      return null;
    }
  };

  const reinitMinicartUpsell = () => {
    if (!window.theme.swiperObjects) window.theme.swiperObjects = [];

    const sliderEl = document.querySelector('[data-minicart-upsell-swiper]');
    if (!sliderEl) return;

    const existingSwiperIndex = window.theme.swiperObjects.findIndex(swiper => swiper?.el === sliderEl);

    if (existingSwiperIndex !== -1) {
      const existingSwiper = window.theme.swiperObjects[existingSwiperIndex];
      if (existingSwiper && !existingSwiper.destroyed) {
        existingSwiper.destroy(true, true);
      }
      window.theme.swiperObjects.splice(existingSwiperIndex, 1);
    }

    const newSwiper = initSwiper(sliderEl);
    window.theme.swiperObjects.push(newSwiper);
  };

  const setLineItemLoadingState = (el) => {
    el?.classList.add('opacity-50');
  };

  const bindMinicartEvents = (renderMinicartFn) => {
    const minicart = document.querySelector('[data-minicart]');
    if (!minicart) return;

    if (minicart.dataset.eventsBound === 'true') return;
    minicart.dataset.eventsBound = 'true';

    minicart.addEventListener('click', async (evt) => {
      const btn = evt.target.closest('[data-minicart-remove-item]');
      if (!btn) return;
      evt.preventDefault();
      btn.classList.add('pointer-events-none');
      const lineItem = btn.closest(minicartLineItemSelector);
      setLineItemLoadingState(lineItem);
      await changeCart(btn.dataset.minicartRemoveItem, 0);
      await renderMinicartFn();
    });

    minicart.addEventListener('change', debounce(SETTINGS.MINICART_DEBOUNCE_DELAY, (evt) => {
      (async () => {
        const input = evt.target.closest('[data-minicart-qty]');
        if (!input) return;

        const lineItem = input.closest(minicartLineItemSelector);
        setLineItemLoadingState(lineItem);
        await changeCart(input.dataset.minicartQty, +input.value);
        await renderMinicartFn();
      })();
    })
    );
  };

  const minicartContent = document.querySelector('[data-minicart-content]');
  const htmlText = await getMinicartData();
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlText, 'text/html');
  const minicartNewData = doc.querySelector('[data-minicart-render]');
  minicartContent.innerHTML = minicartNewData.innerHTML;

  reinitMinicartUpsell();
  initCartUpsellAtc(renderMinicart);
  bindMinicartEvents(renderMinicart);
};

export default renderMinicart;
